export enum EnumStopActionReason {
	"Permanently Cancelled"= "1",
	"Unauthorised Deduction"= "2",
	"Client Found Better Offer"= "3",
	"Personal Reasons"= "4",
	"Unhappy with Service"= "5",
	"QA1"= "6",
	"QA2"= "7",
	"QA3"= "8"
  }
  
  export namespace EnumStopActionReason {
	export function values() {
	  return Object.keys(EnumStopActionReason).filter(
		(type) => isNaN(<any>type) && type !== 'values'
	  );
	}
  }
  